import api from '../api';

// Vínculo da empresa com a conexão do UniService (WhatsApp oficial) e templates
// HSM. Uma única conexão por empresa.

export async function getUniserviceConfig() {
  try {
    const { data } = await api.get('uniservice/config');
    return data;
  } catch {
    return { url: '' };
  }
}

export async function getConnection(companyId) {
  try {
    const { data } = await api.get(`uniservice/connection/${companyId}`);
    return data || null;
  } catch {
    return null;
  }
}

export async function saveConnection(companyId, payload) {
  const { data } = await api.post(`uniservice/connection/${companyId}`, payload);
  return data;
}

export async function removeConnection(companyId) {
  await api.delete(`uniservice/connection/${companyId}`);
}

export async function listTemplates(companyId, status = 'all', includeHidden = false) {
  try {
    const { data } = await api.get(`uniservice/templates/${companyId}`, {
      params: { status, ...(includeHidden ? { includeHidden: true } : {}) },
    });
    return Array.isArray(data) ? data : data?.data ?? [];
  } catch {
    return [];
  }
}

// Restaura (reexibe) um template soft-deleted.
export async function restoreTemplate(companyId, templateId) {
  const { data } = await api.post(`uniservice/templates/${companyId}/${templateId}/restore`);
  return data;
}

export async function syncTemplates(companyId) {
  const { data } = await api.post(`uniservice/templates/${companyId}/sync`);
  return data;
}

// Cria o template padrão do sistema (opt-in de pedido) sob demanda.
export async function createDefaultTemplate(companyId) {
  const { data } = await api.post(`uniservice/templates/${companyId}/default`);
  return data;
}

export async function createTemplate(companyId, payload) {
  const { data } = await api.post(`uniservice/templates/${companyId}`, payload);
  return data;
}

export async function updateTemplate(companyId, templateId, payload) {
  const { data } = await api.patch(`uniservice/templates/${companyId}/${templateId}`, payload);
  return data;
}

export async function deleteTemplate(companyId, templateId) {
  const { data } = await api.delete(`uniservice/templates/${companyId}/${templateId}`);
  return data;
}
